import { UploadType } from '../../consts/uploadType';

export enum MetricsEntity {
  Pano = 'PANO',
  Scan = 'SCAN',
  PpkScan = 'PPKScan',
  LidarScan = 'LIDARScan',
}

export const mapUploadTypeToMetricsEntityType = (uploadType: UploadType): MetricsEntity => {
  return {
    [UploadType.RegularAndRtk]: MetricsEntity.Scan,
    [UploadType.Ppk]: MetricsEntity.PpkScan,
    [UploadType.Lidar]: MetricsEntity.LidarScan,
    [UploadType.Pano]: MetricsEntity.Pano,
  }[uploadType];
};
